import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-travel-pretrip',
    templateUrl: './travel-pretrip.component.html',
    styleUrls: ['./travel-pretrip.component.scss'],
    standalone: false
})
export class TravelPretripComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
